var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"dashboard"},[_c('v-card-text',[_vm._v(_vm._s(_vm.title))]),_c('v-card-title',[_c('span',{staticClass:"text-nowrap"},[_vm._v(_vm._s(_vm.value))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }